import { getWidget, observeElement } from '@uvocore-front/utils';
import '../../components/Header/main';
import '../../components/Footer';
import '../../sections/samples-section';
import { DefaultCalculator } from '../../components/Calculator';

observeElement({
  element: '[data-calc-mini]',
  marginValue: 300,
  callback: () => {
    getWidget({
      widgetLink: '/assets/js/calc.js',
      loader: true,
      fn: () => {
        DefaultCalculator();
      },
    });
  },
});
